import React, { createContext, useContext } from 'react';
import EditBlockWrapper from '@plone/volto/components/manage/Blocks/Block/EditBlockWrapper';
import './alignment.css';

const SectionAlignment = createContext(null);

export function AlignmentBoundary({
  alignment,
  background = 'none',
  children,
}) {
  const value = alignment === 'center' ? 'center' : 'left';
  return (
    <SectionAlignment.Provider value={value}>
      <div
        className="bonn-section-content"
        data-section-alignment={value}
        data-section-background={background}
      >
        {children}
      </div>
    </SectionAlignment.Provider>
  );
}

// RenderBlocks passes one StyleWrapper element to its blockWrapperTag.
// Its props identify the block even when the block renders multiple DOM nodes.
export function SectionViewBlock({ children }) {
  const alignment = useContext(SectionAlignment);
  const { data, block } = React.isValidElement(children) ? children.props : {};
  // Container blocks can forward blockWrapperTag to their own RenderBlocks.
  // Consume this Section's placement once; descendants keep their own layout.
  if (alignment === null) return children;
  return (
    <div
      data-section-block={data?.['@type'] || 'empty'}
      data-section-block-id={block}
      data-section-alignment={alignment}
    >
      <SectionAlignment.Provider value={null}>
        {children}
      </SectionAlignment.Provider>
    </div>
  );
}

export function SectionEditBlock({ draginfo, blockProps, children }) {
  const alignment = useContext(SectionAlignment);
  return (
    <EditBlockWrapper
      blockProps={blockProps}
      draginfo={{
        ...draginfo,
        draggableProps: {
          ...draginfo.draggableProps,
          'data-section-block': blockProps.data['@type'],
          'data-section-block-id': blockProps.block,
          'data-section-alignment': alignment,
        },
      }}
    >
      <SectionAlignment.Provider value={null}>
        {children}
      </SectionAlignment.Provider>
    </EditBlockWrapper>
  );
}

export const renderSectionEditBlock = (dragProps, editBlock, blockProps) => (
  <SectionEditBlock draginfo={dragProps.draginfo} blockProps={blockProps}>
    {editBlock}
  </SectionEditBlock>
);
